//@ts-strict-ignore
import React from 'react';
import styled from 'styled-components';
import { Maybe } from '../../../graphql/schema/p4types';

const InputError = styled.div`
  position: absolute;
  top: 21px;
  font-size: 12px;
  z-index: 100;
  color: ${(props) => props.theme.colors.inputErrorMessage};
  width: 100%;
`;

type IInputErrorMessageProps = {
  label?: Maybe<string>;
  customValidationErrors?: any;
  validationErrors?: Maybe<Array<any> | object>;
  touched?: boolean;
  active?: boolean;
  showWhenNotActive?: boolean;
};

const InputErrorMessage = ({
  label,
  customValidationErrors,
  validationErrors,
  touched,
  active = true,
  showWhenNotActive = true,
}: IInputErrorMessageProps) => {
  let error;
  if (customValidationErrors) {
    error = touched && (active || showWhenNotActive) ? customValidationErrors : null;

    if (error && typeof error === 'object') {
      const errorMessages = Object.values(error).map((message) => message?.toString());
      error = errorMessages.join(',');
    }
  } else {
    error =
      validationErrors && touched && (active || showWhenNotActive)
        ? validationErrors[Object.keys(validationErrors)[0]]
        : null;
  }
  if (error) error = `${label} ${error}`;

  return <InputError>{error}</InputError>;
};

export default InputErrorMessage;
